import React, { useState, useContext, useEffect } from "react"
import { IRestaurant } from "../../types/items"

import { useHttp } from "../../hooks/http.hook"
import * as Contexts from "../../contexts"

import { config, Translater } from "../../config"
import "./delivery.scss"

const ListRestaurants: React.FC<{
  restaurantsList: string
  selectHandler: (e: any) => void
}> = ({ selectHandler, restaurantsList }) => {
  const { token } = useContext(Contexts.AuthContext)
  const { request } = useHttp()
  const { language } = useContext(Contexts.LanguageContext)

  const [primary, setPrimary] = useState<IRestaurant[]>([])

  const Callbacks = {
    Fetch: async () => {
      try {
        const response: IRestaurant[] = await request(
          `${config.API}/restaurants`,
          "GET",
          null,
          {
            Authorization: `Bearer ${token as string}`,
          }
        )
        if (response) {
          setPrimary(response)
        }
      } catch (e) {}
    },
  }

  useEffect(() => {
    Callbacks.Fetch()
  }, [])

  return (
    <select
      name="restId"
      value={restaurantsList}
      onChange={selectHandler}
      className="input-list"
    >
      <option value="" disabled>
        {Translater.Placeholders.chooseRestaurant[language.slug]}
      </option>
      {primary.map(({ _id, title }) => {
        return (
          <option key={_id} value={_id}>
            {title}
          </option>
        )
      })}
    </select>
  )
}

export default ListRestaurants
